import Strings from "../../constants/Strings";
import icons from "../../shared/icons";
import classes from "../../_style/_style.module.scss";

const Footer = (props) => {
  return (
    <div className={classes.footer__container}>
      <div>
        <p>
          <img src={icons.logo_small} alt="renet" />
          {Strings.footer.title}
        </p>
      </div>
      <div>
        <span>{Strings.footer.cerez_politikasi}</span>
        <span>{Strings.footer.aydinlatma_metni}</span>
        <span>{Strings.footer.kullanim_kosullari}</span>
      </div>
    </div>
  );
};

export default Footer;
